import { Controller } from "@hotwired/stimulus"

// Converts currency display (e.g., euros) to cents for form submission
export default class extends Controller {
  static targets = ["display", "cents"]

  connect() {
    // Initialize cents from display value on connect
    this.convert()
  }

  convert() {
    const displayValue = parseFloat(this.displayTarget.value) || 0
    const centsValue = Math.round(displayValue * 100)
    this.centsTarget.value = centsValue
  }
}
